import React from 'react';
import './style.scss';
import { Footer, MouseRing, Navbar } from '../../components';
import { DigitalMarketingDetails, ServiceHero } from '../../layout';
import digitalMarketingVideo from '../../assets/video/marketing-vid.mp4'


const Index = () => {
    return (
        <div className='root'>
            <MouseRing />
            <Navbar />
            <ServiceHero videoUrl={digitalMarketingVideo} />
            <DigitalMarketingDetails />
            <Footer />
            <div className='home__main'>
            </div>
        </div>
    )
}

export default Index